/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CopiedInputs */

const en_copied = /** @type {(inputs: CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied`)
};

const es_copied = /** @type {(inputs: CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiado`)
};

const fr_copied = /** @type {(inputs: CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copié`)
};

const de_copied = /** @type {(inputs: CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiert`)
};

const ja_copied = /** @type {(inputs: CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピーしました`)
};

const zh_copied = /** @type {(inputs: CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已复制`)
};

const ar_copied = /** @type {(inputs: CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم النسخ`)
};

const id_copied = /** @type {(inputs: CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disalin`)
};

const it_copied = /** @type {(inputs: CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiato`)
};

const ru_copied = /** @type {(inputs: CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировано`)
};

const pt_copied = /** @type {(inputs: CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiado`)
};

const ko_copied = /** @type {(inputs: CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`복사됨`)
};

/**
* | output |
* | --- |
* | "Copied" |
*
* @param {CopiedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const copied = /** @type {((inputs?: CopiedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CopiedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_copied(inputs)
	if (locale === "es") return es_copied(inputs)
	if (locale === "fr") return fr_copied(inputs)
	if (locale === "de") return de_copied(inputs)
	if (locale === "ja") return ja_copied(inputs)
	if (locale === "zh") return zh_copied(inputs)
	if (locale === "ar") return ar_copied(inputs)
	if (locale === "id") return id_copied(inputs)
	if (locale === "it") return it_copied(inputs)
	if (locale === "ru") return ru_copied(inputs)
	if (locale === "pt") return pt_copied(inputs)
	return ko_copied(inputs)
});